<div class="activity-bg-section">
    <div class="activity-section">
        <div class="activity-heading-section">
            <span>Activity Details</span>
            <div>
                <div class="each-activity-header-action-section">
                    <button class="each-activity-header-action-button">Delete</button>
                </div>
                <div class="each-activity-header-action-section">
                    <button class="each-activity-header-action-button">Save Activity</button>
                </div>
                <div class="each-activity-header-action-section">
                    <span class="activity-close-icon" (click)="close()">&times;</span>
                </div>
            </div>
        </div>
        <div class="activity-content-section">
            <ng-container *ngIf="!activity_data_loaded">
                <div class="activity-dettails-section">
                    <div class="activity-fields-section">
                        <div class="activity-name-input-section">
                            <p class="activity-name-input-label">Activity Name</p>
                            <input type="text" class="activity-name-input" />
                        </div>
                        <div class="activity-name-input-section">
                            <p class="activity-name-input-label">Description</p>
                            <app-textarea-tagging [users]="tagging_users_list"></app-textarea-tagging>
                            <!-- <app-textarea-tagging [value]="manual_activity_data.description" [users]="tagging_users_list" (valueChanged)="manual_activity_data.description = $event"></app-textarea-tagging> -->
                        </div>
                        <div class="activity-info-tabs-section">
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Comments'}" (click)="activity_tab_selected = 'Comments'">
                                <span>Comments</span>
                            </div>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Attachments'}" (click)="activity_tab_selected = 'Attachments'">
                                <span>Attachments</span>
                            </div>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Sub Tasks'}" (click)="activity_tab_selected = 'Sub Tasks'">
                                <span>Sub Tasks</span>
                            </div>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Response'}" (click)="activity_tab_selected = 'Response'">
                                <span>Response</span>
                            </div>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'History'}" (click)="activity_tab_selected = 'History'">
                                <span>History</span>
                            </div>
                        </div>
                        <ng-container *ngIf="activity_tab_selected == 'Comments'">
                            <span>Comments</span>
                        </ng-container>
                        <ng-container *ngIf="activity_tab_selected == 'Attachments'">
                            <span>Attachments</span>
                        </ng-container>
                        <ng-container *ngIf="activity_tab_selected == 'Sub Tasks'">
                            <span>Sub Tasks</span>
                        </ng-container>
                        <ng-container *ngIf="activity_tab_selected == 'Response'">
                            <span>Response</span>
                        </ng-container>
                        <ng-container *ngIf="activity_tab_selected == 'History'">
                            <span>History</span>
                        </ng-container>
                    </div>
                    <div class="activity-action-section">
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Status</span>
                            <mat-select class="activity-action-input" [(ngModel)]="activity_data.status"> 
                                <mat-option [value]="''">None</mat-option> 
                                <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Assignee</span>
                            <mat-select class="activity-action-input" [(ngModel)]="activity_data.status"> 
                                <mat-option [value]="''">Self</mat-option> 
                                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
                            </mat-select>
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Scheduled Date</span>
                            <input
                                type="text"
                                class="activity-action-input"
                                bsDatepicker
                                placement="left"
                                [(ngModel)]="activity_data.scheduled_date"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                            />
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Actual Date</span>
                            <input
                                type="text"
                                class="activity-action-input"
                                bsDatepicker
                                placement="left"
                                [(ngModel)]="activity_data.scheduled_date"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                            />
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Communication Channel</span>
                            <mat-select class="activity-action-input" [(ngModel)]="activity_data.status"> 
                                <mat-option [value]="''">None</mat-option> 
                                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id">{{ communication.name }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="activity_data_loaded">
                <app-loader [loading_text]="'Loading Activity Data'"></app-loader>
            </ng-container>
        </div>
    </div>
</div>